module.exports = __webpack_public_path__ + "img/album14_31.dde85b89.jpg";